import {
  legacy_createStore as createStore,
  applyMiddleware,
  compose,
} from "redux";
import thunk from "redux-thunk";
import rootReducer from "./root-reducer";
import logger from "redux-logger";

let middlewares = [thunk];

if (process.env.NODE_ENV === "development") {
  middlewares.push(logger);
}

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// compose enhancers
const composedEnhancers = composeEnhancer(applyMiddleware(...middlewares));

const store = createStore(rootReducer, composedEnhancers);

export default store;
